const japanPrefectures = {
  OVERSEA: '海外',
  HOKKAIDO: '北海道',
  AOMORI: '青森縣',
  IWATE: '岩手縣',
  MIYAGI: '宮城縣',
  AKITA: '秋田縣',
  YAMAGATA: '山形縣',
  FUKUSHIMA: '福島縣',
  IBARAKI: '茨城縣',
  TOCHIGI: '櫪木縣',
  GUNMA: '群馬縣',
  SAITAMA: '埼玉縣',
  CHIBA: '千葉縣',
  TOKYO: '東京都',
  KANAGAWA: '神奈川縣',
  NIIGATA: '新潟縣',
  TOYAMA: '富山縣',
  ISHIKAWA: '石川縣',
  FUKUI: '福井縣',
  YAMANASHI: '山梨縣',
  NAGANO: '長野縣',
  GIFU: '岐阜縣',
  SHIZUOKA: '靜岡縣',
  AICHI: '愛知縣',
  MIE: '三重縣',
  SHIGA: '滋賀縣',
  KYOTO: '京都府',
  OSAKA: '大阪府',
  HYOGO: '兵庫縣',
  NARA: '奈良縣',
  WAKAYAMA: '和歌山縣',
  TOTTORI: '鳥取縣',
  SHIMANE: '島根縣',
  OKAYAMA: '岡山縣',
  HIROSHIMA: '廣島縣',
  YAMAGUCHI: '山口縣',
  TOKUSHIMA: '德島縣',
  KAGAWA: '香川縣',
  EHIME: '愛媛縣',
  KOCHI: '高知縣',
  FUKUOKA: '福岡縣',
  SAGA: '佐賀縣',
  NAGASAKI: '長崎縣',
  KUMAMOTO: '熊本縣',
  OITA: '大分縣',
  MIYAZAKI: '宮崎縣',
  KAGOSHIMA: '鹿兒島縣',
  OKINAWA: '沖繩縣'
};

export default japanPrefectures;
